var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "draggable",
    _vm._b(
      {
        staticClass: "list-group",
        on: {
          start: function ($event) {
            _vm.drag = true
          },
          end: function ($event) {
            _vm.drag = false
          },
          update: _vm.update,
        },
        model: {
          value: _vm.checkedList,
          callback: function ($$v) {
            _vm.checkedList = $$v
          },
          expression: "checkedList",
        },
      },
      "draggable",
      _vm.dragOptions,
      false
    ),
    [
      _c(
        "transition-group",
        { attrs: { type: "transition", name: "flip-list" } },
        _vm._l(_vm.checkedList, function (item, index) {
          return _c(
            "div",
            { key: item.prop, class: { "padding-children": _vm.isChildren } },
            [
              item.prop !== "sortIndex" && item.type !== "selection"
                ? _c(
                    "div",
                    { staticClass: "flex-between flex-1 padding-y-3" },
                    [
                      _c(
                        "div",
                        { staticClass: "flex-start" },
                        [
                          !_vm.isChildren
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "padding-x-5 padding-y-2 margin-right-5",
                                  class: [item.fixed ? "" : "handle"],
                                },
                                [
                                  item.fixed
                                    ? _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            effect: "dark",
                                            content: "固定后不可移动位置",
                                            placement: "top-start",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-info color-999 font-12",
                                          }),
                                        ]
                                      )
                                    : _c("i", {
                                        staticClass:
                                          "el-icon-rank font-12 color-333",
                                      }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c("Checkbox", {
                            key: item.prop,
                            attrs: {
                              disabled: _vm.isChildren,
                              label: item.label,
                            },
                            on: {
                              change: function ($event) {
                                return _vm.onItemChange($event, item, index)
                              },
                            },
                            model: {
                              value: item.checked,
                              callback: function ($$v) {
                                _vm.$set(item, "checked", $$v)
                              },
                              expression: "item.checked",
                            },
                          }),
                        ],
                        1
                      ),
                      !_vm.isChildren && _vm.showFixed
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "flex-1 flex flex-justify-end flex-align-center",
                            },
                            [
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    effect: "dark",
                                    content: "固定在左侧",
                                    placement: "top",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "padding-x-5 padding-y-2 pointer",
                                      on: {
                                        click: function ($event) {
                                          return _vm.changeFixed(
                                            item,
                                            "left",
                                            index
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-back font-16",
                                        class: [
                                          item.fixed === "left" ? "active" : "",
                                        ],
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    effect: "dark",
                                    content: "固定在右侧",
                                    placement: "top",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "padding-x-5 padding-y-2 pointer",
                                      on: {
                                        click: function ($event) {
                                          return _vm.changeFixed(
                                            item,
                                            "right",
                                            index
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-right font-16",
                                        class: [
                                          item.fixed === "right"
                                            ? "active"
                                            : "",
                                        ],
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
              item.children && item.children.length > 0
                ? _c("TreeColumn", {
                    attrs: { isChildren: true, list: item.children },
                  })
                : _vm._e(),
            ],
            1
          )
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }